// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".detail-container[data-v-2da57cce]{display:grid;grid-template-columns:100px auto;row-gap:7px}.detail-container p[data-v-2da57cce]{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
